import { makeAutoObservable } from 'mobx';
import { inject, injectable } from 'inversify';
import { type AccountReportsModule, AccountReportsModuleIdentifier } from '@shared/types/mobx/services/accountReports';
import { type OsiService, OsiServiceIdentifier } from '@shared/types/mobx/services/osi';

@injectable()
export class OsiRootViewModel {
  changeModeModalIsOpen = false;

  constructor(
    @inject(OsiServiceIdentifier) private osiModule: OsiService,
    @inject(AccountReportsModuleIdentifier) private accountReportsModule: AccountReportsModule
  ) {
    makeAutoObservable(this);
  }

  get osiName() {
    return this.osiModule.osiInfo?.name;
  }

  get osiAddress() {
    return this.osiModule.osiInfo?.address;
  }

  get isLoading() {
    return this.osiModule.isLoading;
  }

  get menuItems() {
    return this.osiModule.menuItems;
  }

  get isFreeMode() {
    return this.osiModule.osiInfo?.registrationType === 'FREE';
  }

  openChangeModeModal = () => {
    this.changeModeModalIsOpen = true;
  };

  closeChangeModeModal = () => {
    this.changeModeModalIsOpen = false;
  };

  onChangeModeClicked = () => {
    this.closeChangeModeModal();
  };

  loadOsiAccountReports = async () => {
    if (!this.osiModule.osiInfo?.id) return;

    await this.accountReportsModule.loadReports();
  };
}
